import * as Constants from 'constants/index';

type LicenseDetailsState = Record<string, boolean>;

// Action carries the selected license `id`; typed minimally at the reducer boundary.
interface LicenseDetailsAction {
  type: string;
  id?: string;
}

const initialState: LicenseDetailsState = {};

export const LicenseDetailsReducer = (
  state: LicenseDetailsState = initialState,
  action: LicenseDetailsAction,
): LicenseDetailsState => {
  switch (action.type) {
    case Constants.SuperAdmin.TABLE_ACTION_TYPES.SELECT_LICENSE_DETAILS:
      return {
        [action.id as string]: true,
      };
    default:
      return state;
  }
};
